import { Component } from '@angular/core';

@Component({
  selector: 'app-settings-icon',
  templateUrl: './settings-icon.component.html',
})
export class SettingsIconComponent {

}
